import { API, authClient } from "..";

export const getTexts = ({ game, key }) => {
	const params = {};
	if (game) params.game = game;
	if (key) params.key = key;

	return authClient().get(`${API}/text`, { params });
};

export const createText = (body) => {
	return authClient().post(`${API}/text`, body);
};

export const updateText = (id, body) => {
	return authClient().put(`${API}/text/${id}`, body);
};

